import React, { useState, useEffect , useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import {useReactToPrint} from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle'; 


function YearMaster(props) {
  const [rooms, setRooms] = useState([]);
  const [YearCode, setYearCode] = useState(0);
  const [StartYear, setStartYear] = useState('');
  const [EndYear, setEndYear] = useState('');
  const [FinancialYear, setFinancialYear] = useState('');
  const [DeptCode, setDeptCode] = useState(0);
  const [DeptName, setDeptName] = useState('');
  const [CompName, setCompName] = useState('');

/*   const formattedStartYear = new Date(StartYear).toISOString().split('T')[0];
  const formattedEndYear = new Date(EndYear).toISOString().split('T')[0];
 */
  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [formMode, setFormMode] = useState('add');
  const [editRoomId, setEditRoomId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [yearMasterEntries, setYearMasterEntries] = useState([]);
  const [deptMasterEntries, setDeptMasterEntries] = useState([]);
  const [compMasterEntries, setCompMasterEntries] = useState([]);
  const [CompCode, setCompCode] = useState(0);
  
  const [deleteEntryNo, setDeleteEntryNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);


  useEffect(() => {
    fetchYearMaster();
    fetchDeptMaster();
    fetchCompMaster();
  }, []);

  const fetchDeptMaster = async () =>{
    try{
      const response = await axios.get('https://www.wingap.net.in/api/items');
      setDeptMasterEntries(response.data);
      //console.log(response);
    }catch(error){
      console.log('error:', error);
    }
  };

  const fetchCompMaster = async () =>{
    try{
      const response = await axios.get('https://www.wingap.net.in/api/company');
      setCompMasterEntries(response.data);
      //console.log(response);
    }catch(error){
      console.log('error:', error);
    }
  };

  const fetchYearMaster = async () =>{
    try{
      const response = await axios.get('https://www.wingap.net.in/api/year_master');
      setYearMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1;
      setYearCode(nextEntryNo)
      //console.log(response)
    }catch(error){
      console.log('error:', error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
      if (entry.YearCode > maxEntryNo) {
        maxEntryNo = entry.YearCode;
      }
    }
    return maxEntryNo;
  };



  const addMaster = async () => {
    const formattedStartYear = new Date(StartYear).toISOString().split('T')[0];
    const formattedEndYear = new Date(EndYear).toISOString().split('T')[0];

    try {
      await axios.post('https://www.wingap.net.in/api/year_master', {
        YearCode: YearCode,
        StartYear: formattedStartYear,
        EndYear: formattedEndYear,
        FinancialYear: FinancialYear,
        DeptCode: DeptCode,
        CompCode: CompCode,
        USERID: props.name
      });
      fetchYearMaster();
      setYearCode('');
      setStartYear('');
      setEndYear('');
      setFinancialYear('');
      setDeptCode('');
      setCompCode('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateRoom = async (YearCode) => {
    const formattedStartYear = new Date(StartYear).toISOString().split('T')[0];
    const formattedEndYear = new Date(EndYear).toISOString().split('T')[0];

    try {
      await axios.put(`https://www.wingap.net.in/api/year_master/${YearCode}`, {
        YearCode: YearCode,
        StartYear: formattedStartYear,
        EndYear: formattedEndYear,
        FinancialYear: FinancialYear,
        DeptCode: DeptCode,
        CompCode: CompCode,
        USERID: props.name
      });
      fetchYearMaster();
      setYearCode('');
      setStartYear('');
      setEndYear('');
      setFinancialYear('');
      setDeptCode('');
      setCompCode('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };
  
  const handleDeleteConfirmation = async () => {
    try {
      if (deleteEntryNo) {
        await deleteRoom(deleteEntryNo.YearCode);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteRoom = async (YearCode) => {
    try {
     const response = await axios.delete(`https://www.wingap.net.in/api/year_master/${YearCode}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        fetchYearMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  };  

  const setEditForm = (room) => {
    setFormMode('edit');
    setYearCode(room.YearCode);
    setStartYear(room.StartYear);
    setEndYear(room.EndYear);
    setFinancialYear(room.FinancialYear);
    setDeptCode(room.DeptCode);
    const selectedGroup = deptMasterEntries.find(group => group.DeptCode == room.DeptCode);
    if (selectedGroup) {
      setDeptName(selectedGroup.DeptName);
    }
    setCompCode(room.CompCode);
    const selectedGroup1 = compMasterEntries.find(group => group.CompCode == room.CompCode);
    if (selectedGroup1) {
      setCompName(selectedGroup.CompName);
    }
    setShowGrid(false);
  };

 
 /*  const handleSearch = (searchQuery) => {
    const filtered = rooms.filter((room) => {
      // Convert room.RoomNo, room.deptName, etc., to strings before using includes
      const deptCode = room.DeptCode.toString().toLowerCase();
      const deptName = room.deptName.toString().toLowerCase();
      const deptNameENG = room.deptNameENG.toString().toLowerCase();
      const compCode = room.compCode.toString().toLowerCase();
      const flag = room.flag.toString().toLowerCase();

      // Check if any of the properties contain the searchQuery (converted to lowercase)
      return (
        deptCode.includes(searchQuery.toLowerCase()) ||
        deptName.includes(searchQuery.toLowerCase()) ||
        deptNameENG.includes(searchQuery.toLowerCase()) ||
        compCode.includes(searchQuery.toLowerCase()) ||
        flag.includes(searchQuery.toLowerCase())
      );
    });

    // Update the deptMasterEntries state with the filtered results
    setDeptMasterEntries(filtered);
  }; 

  // ... Rest of your code ...

  // Update the filtered rooms based on the searchQuery prop
  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, rooms]);*/

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setRooms(rooms); 
    if (compMasterEntries.length === 1) {
      setCompCode(compMasterEntries[0].CompCode);
    }
    if (deptMasterEntries.length === 1) {
      DeptCode(compMasterEntries[0].DeptCode);
    }
  }

  const handleCancel = () => {
    setFormMode('add');
    setEditRoomId('');
    setYearCode('');
    setStartYear('');
    setEndYear('');
    setFinancialYear('');
    setDeptCode('');
    setCompCode('');
  }

   
  const componentPDF= useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "Year Master Data",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (

    <div style={{ maxWidth: '100%', margin: '0 auto',padding: '20px' }} >
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Year Master</h1>
      <Grid item>
          <Button
            variant="contained"
            className="view-button"
            onClick={handleshowandhide}
            sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float:'right'}}
          >
            {showGrid ? 'Add' : 'Back'}
          </Button>
        </Grid>
        {showGrid && <Grid item>
          <Button
            variant="contained"
            onClick={generatePDF}
            sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float:'right', marginRight:"10px"}}
          >
            Download PDF
          </Button>
        </Grid>}
        {showGrid && <Grid item>
          <Button
            variant="contained"
            // onClick={generatePDF}
            sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float:'right', marginRight:"10px"}}
          >
            Export
          </Button>
        </Grid>}
        {!showGrid && (
           <>
           <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
           <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="YearCode" style={{ width: '150px', marginRight: '10px' }}>YearCode</label>
               <input
                 type="text"
                 value={YearCode}
                 readOnly
                 placeholder="YearCode"
                 style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="StartYear" style={{ width: '150px', marginRight: '10px' }}>StartYear</label>
               <input
                 type="date"
                 value={StartYear}
                 onChange={(e) => setStartYear(e.target.value)}
                 placeholder="StartYear"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
                 list="years"
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="EndYear" style={{ width: '150px', marginRight: '10px' }}>EndYear</label>
               <input
                 type="date"
                 value={EndYear}
                 onChange={(e) => setEndYear(e.target.value)}
                 placeholder="EndYear"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="FinancialYear" style={{ width: '150px', marginRight: '10px' }}>FinancialYear</label>
               <input
                 type="text"
                 value={FinancialYear}
                 onChange={(e) => setFinancialYear(e.target.value)}
                 placeholder="FinancialYear"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="DeptCode" style={{ width: '150px', marginRight: '10px' }}>DeptCode</label>
               <input
                 type="number"
                 value={DeptCode}
                 onChange={(e) => {
                  const selectedGroupName = e.target.value;
                  setDeptCode(selectedGroupName);
                  console.log("selectedGroupCode",selectedGroupName);
                  const selectedGroup = deptMasterEntries.find(group => group.DeptCode == selectedGroupName);
                  console.log("selectedGroup",selectedGroup);

                  if (selectedGroup) {
                    setDeptName(selectedGroup.DeptName);
                  }
                 }}
                 placeholder="DeptCode"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="DeptName" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>DeptName</label>
            <select
              value={DeptName}
              onChange={(e) => {
                const selectedGroupName = e.target.value;
                setDeptName(selectedGroupName);
                const selectedGroup = deptMasterEntries.find(group => group.DeptName === selectedGroupName);
                if (selectedGroup) {
                  setDeptCode(selectedGroup.DeptCode);
                }
              }}
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            >{
              deptMasterEntries.map((group) => (
                  <option key={group.DeptCode} value={group.DeptName}>{group.DeptName}</option>
                ))
              }</select>
          </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="CompCode" style={{ width: '150px', marginRight: '10px' }}>CompCode</label>
               <input
                 type="number"
                 value={CompCode}
                 onChange={(e) => 
                {
                  const selectedGroupName = e.target.value;
                  setCompCode(selectedGroupName);
                  const selectedGroup = compMasterEntries.find(group => group.CompCode === selectedGroupName);
                  if (compMasterEntries.length === 1) {
                    // If there's only one entry, set CompCode directly
                    setCompCode(compMasterEntries[0].CompCode);
                  }
                  if (selectedGroup) {
                  setCompCode(selectedGroup.CompName);
                  }
                }}
                 placeholder="CompCode"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="CompName" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>CompName</label>
            <select
              value={CompName}
              onChange={(e) => {
                const selectedGroupName = e.target.value;
                setCompName(selectedGroupName);
                const selectedGroup = compMasterEntries.find(group => group.CompName === selectedGroupName);
                if (selectedGroup) {
                  setCompCode(selectedGroup.CompCode);
                } else if (compMasterEntries.length === 1) {
                  // If there's only one entry, set CompCode directly
                  setCompCode(compMasterEntries[0].CompCode);
                } else {
                  // Handle the case when no matching or multiple entries are found
                  setCompCode(''); // or handle it in a way that makes sense for your application
                }
              }}
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            >{
              compMasterEntries.map((group) => (
                  <option key={group.CompCode} value={group.CompName}>{group.CompName}</option>
                ))
              }</select>
          </div>
             </div>
           <div>
             <button
               className={formMode === 'add' ? 'add-button' : 'update-button'}
               onClick={formMode === 'add' ? addMaster : () => updateRoom(YearCode)}
               style={{
                 padding: '10px 20px',
                 fontSize: '16px',
                 backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
                 color: 'white',
                 border: 'none',
                 cursor: 'pointer',
                 marginBottom: '10px',
               }}
             >
               {formMode === 'add' ? 'Add' : 'Update'}
             </button>
             <button
               className="view-button"
               onClick={handleCancel}
               style={{
                 padding: '10px 20px',
                 fontSize: '16px',
                 backgroundColor: '#f44336',
                 color: 'white',
                 border: 'none',
                 cursor: 'pointer',
                 marginLeft: '10px',
                 marginBottom: '10px',
               }}
             >
               Cancel
             </button>
           </div>
         </>
         
          )}
        {showGrid && (
            <div ref={componentPDF} style={{width:'100%'}}>
              <h2>Entries</h2>
              <table
                style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  border: '1px solid #ccc',
                }}
              >
                <thead>
                  <tr style={{ background: '#f2f2f2', color:'black' }}>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      YearCode
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      Start Year
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      End Year
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      Financial Year
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      DeptCode
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      CompCode
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {yearMasterEntries.map((room) => (
                    <tr key={room.yearCode} style={{backgroundColor:'white', color:'black', textAlign:'center'}}>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.YearCode}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.StartYear}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.EndYear}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.FinancialYear}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.DeptCode}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.CompCode}</td>
                      <td className="print-hide" >
                        <button
                          style={{
                            padding: '5px 10px',
                            backgroundColor: 'rgb(76, 175, 80)',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            marginRight: '5px',
                            marginLeft:'10px',
                          }}
                          onClick={() => setEditForm(room)}
                        >
                          Edit
                        </button>
                        <button
                          style={{
                            padding: '5px 10px',
                            backgroundColor: 'rgb(244, 67, 54)',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setDeleteEntryNo({YearCode: room.YearCode});
                            setOpenConfirmation(true); 
                          }}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center'}} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{fontSize:'16px'}} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>

      <Dialog
                open={openConfirmation}
                onClose={() => setOpenConfirmation(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Are you sure you want to DELETE ?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                    Cancel
                  </Button>
                  <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>
    </div>
  );
}

export default YearMaster;